var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivilegesButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7391 2.13986C10.1919 2.13986 7.90982 1.72065 6.14478 0.543865C6.10191 0.515264 6.05153 0.5 5.99999 0.5C5.94846 0.5 5.89808 0.515264 5.85521 0.543865C4.09017 1.72065 1.80809 2.13986 0.260869 2.13986C0.191682 2.13986 0.125329 2.16735 0.0764068 2.21627C0.0274844 2.26519 0 2.33155 0 2.40073C0 7.12899 2.20461 10.8965 5.89721 12.4789C5.92969 12.4928 5.96466 12.5 5.99999 12.5C6.03533 12.5 6.0703 12.4928 6.10278 12.4789C9.79538 10.8965 12 7.12899 12 2.40073C12 2.33155 11.9725 2.26519 11.9236 2.21627C11.8747 2.16735 11.8083 2.13986 11.7391 2.13986ZM5.73913 1.23047V6.23916H1.08991C0.730159 5.07874 0.53959 3.8725 0.524086 2.65769C2.35154 2.60573 4.13988 2.11631 5.73913 1.23047ZM6.26086 11.8272V6.7609H10.7301C9.96001 8.96879 8.35564 10.7871 6.26086 11.8262V11.8272Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivilegesButton);
export default __webpack_public_path__ + "static/media/privileges_button.4fefcf32203180432815648fa606722f.svg";
export { ForwardRef as ReactComponent };